import { Directive, ElementRef, forwardRef, HostListener, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { isNullOrUndefined } from '../../utils';

@Directive({
    selector: '[uzNumericInput]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => NumericInputDirective),
            multi: true
        }
    ],
    standalone: true
})
export class NumericInputDirective implements ControlValueAccessor {
  constructor(private _elementRef: ElementRef, private _renderer: Renderer2) {}

  @HostListener('blur', []) onBlur() {
    this.onTouchedCallback();
  }

  @HostListener('input', ['$event']) onInputChange(event) {
    this.updateControlValue(this._elementRef.nativeElement.value);
  }

  onChangeCallback = (value: any) => {};
  onTouchedCallback = () => {};

  writeValue(value: any) {
    const strippedValue: string = isNullOrUndefined(value) ? value : value.toString().replace(/[^0-9]*/g, '');

    this._renderer.setProperty(this._elementRef.nativeElement, 'value', strippedValue);
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
  }

  private updateControlValue(value: any) {
    const strippedValue: string = isNullOrUndefined(value) ? value : value.toString().replace(/[^0-9]*/g, '');

    this._renderer.setProperty(this._elementRef.nativeElement, 'value', strippedValue);
    this.onChangeCallback(strippedValue);
  }
}
